// src/components/SingleSelect.jsx

import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  CircularProgress,
  FormHelperText,
} from "@mui/material";
import { useEffect, useState } from "react";
import useGraphQLClient from "../hooks/useGraphQLClient";

const SingleSelect = ({
  label,
  name,
  value,
  query,
  variables = {},
  skip = false,
  dataKey,
  valueKey = "id",
  labelKey = "name",
  onChange,
  onBlur,
  error,
  touched,
}) => {
  const client = useGraphQLClient();

  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (skip) {
      setOptions([]);
      return;
    }

    let isMounted = true;

    const fetchOptions = async () => {
      try {
        setLoading(true);

        const res = await client.request(query, variables);

        if (!isMounted) return;

        setOptions(res[dataKey] || []);
      } catch (err) {
        console.error(`Error loading ${label} options`, err);
        setOptions([]);
      } finally {
        if (isMounted) setLoading(false);
      }
    };

    fetchOptions();

    return () => {
      isMounted = false;
    };
  }, [query, JSON.stringify(variables), skip]);

  const handleChange = (event) => {
    onChange(name, event.target.value);
  };

  return (
    <FormControl
      fullWidth
      variant="filled"
      error={!!touched && !!error}
      sx={{ gridColumn: "span 2" }}
    >
      <InputLabel>{label}</InputLabel>

      <Select
        name={name}
        value={value || ""}
        onChange={handleChange}
        onBlur={onBlur}
      >
        {loading && (
          <MenuItem disabled>
            <CircularProgress size={20} />
          </MenuItem>
        )}

        {!loading && options.length === 0 && (
          <MenuItem disabled>No options</MenuItem>
        )}

        {options.map((opt) => (
          <MenuItem key={opt[valueKey]} value={opt[valueKey]}>
            {opt[labelKey]}
          </MenuItem>
        ))}
      </Select>

      {touched && error && <FormHelperText>{error}</FormHelperText>}
    </FormControl>
  );
};

export default SingleSelect;